// Generated by CoffeeScript 2.7.0
Number.prototype.zeroFill = function(length = 2) {
  var _str;
  if (this >= Math.pow(10, length)) {
    return this.toString();
  } else {
    _str = Array(length + 1).join('0') + this;
    return _str.slice(_str.length - length);
  }
};

Number.prototype.toTimeFormat = function() {
  var _hour, _minute, _second, _time;
  _hour = 0;
  _second = parseInt(this);
  if (_second > 3600) {
    _hour = parseInt(_second / 3600);
    _second = _second % 3600;
  }
  _minute = parseInt(_second / 60);
  _second = _second % 60;
  _time = `${_minute.zeroFill()}:${_second.zeroFill()}`;
  if (_hour) {
    return `${_hour.zeroFill()}:${_time}`;
  } else {
    return _time;
  }
};
